import { YesNo } from "../model/enumerations/yes-no.model";
import { ISelect } from "../model/iSelect";

export const yesNoEnum = (): Array<ISelect> => {
  const yesNo: Array<ISelect> = [
    {
      label: `Sí`,
      value: YesNo.YES,
    },
    {
      label: `No`,
      value: YesNo.NO,
    },
  ];
  return yesNo;
};
